export const LOAD_SHOPS = 'LOAD_SHOPS';

export const LOAD_CATEGORIES = 'LOAD_CATEGORIES';

export const SELECT_CATEGORY = 'SELECT_CATEGORY';
export const SELECT_ONE_PRODUCT = 'SELECT_ONE_PRODUCT';
export const CLEAR_ONE_PRODUCT = 'CLEAR_ONE_PRODUCT';

export const ADD_TO_CART = 'ADD_TO_CART';
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART';
export const CLEAR_CART = 'CLEAR_CART';

export const COUNT_DELIVERY_PRICE = 'COUNT_DELIVERY_PRICE';

export const SHOW_CONTACT_POPUP = 'SHOW_CONTACT_POPUP';
export const HIDE_CONTACT_POPUP = 'HIDE_CONTACT_POPUP';
export const SEND_CONTACT_POPUP = 'SEND_CONTACT_POPUP';

export const BILLING_DETAILS = 'BILLING_DETAILS';

export const CREATE_ORDER = 'CREATE_ORDER';

export const CLEAR_DELIVERY_DATA = 'CLEAR_DELIVERY_DATA';

export const DELIVERY_DETAILS = 'DELIVERY_DETAILS';

export const START = '_START';
export const SUCCESS = '_SUCCESS';
export const FAIL = '_FAIL';


// WEBPACK FOOTER //
// ./src/constants/index.js